import React from 'react'
import { currencies } from 'utils'

export const CurrencyContext = React.createContext(currencies[0])
